const formatTime = (dateTime: Date) => {
  return new Date(dateTime).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

export default formatTime;
